import { Flex, StyleProps, Text } from '@chakra-ui/react';
import {
  PublicUserFragment,
  UserFragment,
} from '@client/graphql/__generated__/types';
import { UserAvatar } from '../User/UserAvatar';

interface PreparedByProps extends StyleProps {
  agent?: UserFragment | PublicUserFragment;
}

export const PreparedBy = ({ agent, ...styleProps }: PreparedByProps) => {
  if (!agent) return null;

  return (
    <Flex alignItems="center" gap={3} height="100%" px={4} {...styleProps}>
      <Text
        color="white"
        fontSize="md"
        fontWeight="medium"
        noOfLines={1}
        whiteSpace="nowrap"
      >
        Prepared by
      </Text>
      <Flex alignItems="center" gap={2}>
        <UserAvatar
          size="sm"
          user={{
            fullName: agent.fullName,
            profilePicture: agent.profilePicture,
          }}
        />
        <Text
          color="white"
          fontSize="md"
          fontWeight="medium"
          noOfLines={1}
          whiteSpace="nowrap"
        >
          {agent.fullName}
        </Text>
      </Flex>
    </Flex>
  );
};
